import React, { Fragment } from 'react';

import ModalHeader from '@common-components/headers/ModalHeader';
import TicketForm from '../forms/TicketForm';

const TicketTypeModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: {
            modalData,
            modalData: {
                headerText
            }
        }

    } = props;

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader {...modalHeaderProps } modalHeaderTextData={headerText}  />
            </div>
            <div className="gi-modal__body ticket-mgmt-form">
                <TicketForm {...{ ...modalData, onCancelHandler: hideModal } }/>
            </div>
        </Fragment>
    );
};

export default TicketTypeModal;
